import React, { useEffect, useState } from 'react';

const EmojiRating = ({readOnly=false, initialRating=0, emojisSize=40, ratingCallback = () => {}}) => {

    const [rating, setRating] = useState(initialRating);
    useEffect(() => {
     if(initialRating) {setRating(initialRating)}
    }, [initialRating])

  const handleClick = (value) => {
    if(readOnly) return
    setRating(value);
    ratingCallback(value)
  };

  const emojiStyle = (value) => {
    return {
      fontSize: rating === value ? `${emojisSize + (emojisSize * 0.2)}px` :  `${emojisSize}px`,
      cursor: readOnly ? 'default' :'pointer',
      margin: '0 5px',
      opacity: rating === value ? 1 : 0.5,
      borderRadius: '50%',
      padding: rating === value ? '5px' : '0',
    };
  }

  return (
    <div style={{ display: 'flex',  justifyContent: 'center', alignItems: 'center' }}>
      <span
        onClick={() => handleClick(1)}
        style={{...emojiStyle(1)}}
      >
        😞
      </span>
      <span
        onClick={() => handleClick(2)}
        style={{...emojiStyle(2)}}
      >
        😐
      </span>
      <span
        onClick={() => handleClick(3)}
        style={{...emojiStyle(3)}}
      >
        🙂
      </span>
      <span
        onClick={() => handleClick(4)}
        style={{...emojiStyle(4)}}
      >
        😄
      </span>
    </div>
  );
};

export default EmojiRating;